import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { OrderFlowContainer } from './features/OrderFlow/OrderFlowContainer';
import { ComponentPreview } from './components/ComponentPreview';

// 現在のURLから動的にbasenameを取得する関数
const getBasename = (): string => {
  const pathname = window.location.pathname;
  
  // 多言語URL対応: /{locale}/pages/flow パターンをチェック
  const localeMatch = pathname.match(/^\/([a-z]{2})\/pages\/flow/);
  if (localeMatch) {
    // 言語プレフィックス付きURL（例: /en/pages/flow, /fr/pages/flow など）
    return `/${localeMatch[1]}/pages/flow`;
  } else if (pathname.startsWith('/pages/flow')) {
    // デフォルト言語URL（例: /pages/flow）
    return '/pages/flow';
  }
  
  // フォールバック: デフォルトのパス
  return '/pages/flow';
};

const App: React.FC = () => {
  const basename = getBasename();
  
  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path="/" element={<OrderFlowContainer />} />
        <Route path="/order" element={<Navigate to="/" />} />
        <Route path="/preview" element={<ComponentPreview />} />
        {/*
          動的basename対応:
          - 日本語（デフォルト）: basename="/pages/flow" → "/" は "/pages/flow" にマッチ
          - 英語: basename="/en/pages/flow" → "/" は "/en/pages/flow" にマッチ
          - 他の言語: basename="/{locale}/pages/flow" → "/" は "/{locale}/pages/flow" にマッチ
        */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;